import { TreeNode } from '../../hooks/stores/launcherElementsStore';

export const findNodePath = (tree: TreeNode[], id: string, currentPath: string[] = []): string[] => {
  for (const node of tree) {
    if (node.id === id) {
      currentPath = [...currentPath, node.id];
      return currentPath;
    }
    if (node.children) {
      const path = findNodePath(node.children, id, [...currentPath, node.id]);
      if (path.length) {
        return path;
      }
    }
  }
  return [];
};
